export const AuthInterceptor: (req: any, next: any) => any = (req: any, next: any) => {
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');

  const header: any = {'HMS-KEY': '5dd26ca2624be'}
  if (currentUser?.api_key) {
    const token = window.btoa(`${currentUser.user_id}:${currentUser.api_key}`);
    header.Authorization = `Bearer ${token}`;
  }
  req = req.clone({
    setHeaders: header,
  });
  // console.info('Interceptor:', req);
  return next(req);
};
